export const isZoomTranscriptFormat = (transcript: string): boolean => {
  const lines = transcript.split('\n').filter((line) => line.trim() !== '')
  if (lines.length < 2) return false

  // Zoomの特徴的な形式をチェック
  // - [話者名] HH:mm:ss の形式
  // 1行目が話者名の形式であるかどうかをチェック
  const speakerLineRegex = /^\[[^\]]+\]\s+\d{2}:\d{2}:\d{2}$/
  const firstLine = lines[0].trim()

  return speakerLineRegex.test(firstLine)
}

export const validateZoomTranscriptFormat = (transcript: string) => {
  const lines = transcript.split('\n').filter((line) => line.trim() !== '')
  const regexSpeakerLine = /^\[([^\]]+)\] \d{2}:\d{2}:\d{2}$/

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i].trim()

    if (i % 2 === 0) {
      if (!regexSpeakerLine.test(line)) {
        return false
      }

      const parts = line.split(' ')
      const timestamp = parts[parts.length - 1]
      const [hours, minutes, seconds] = timestamp.split(':').map(Number)

      if (
        hours < 0 ||
        hours > 23 ||
        minutes < 0 ||
        minutes > 59 ||
        seconds < 0 ||
        seconds > 59
      ) {
        return false
      }
    } else {
      if (!line) {
        return false
      }
    }
  }

  return true
}

// batch/src/modules/transcriptParser/zoomParser.ts と同じ正規表現。
// batch が 90 秒判定に使う話者行の時刻だけを数え、発言本文中の時刻は無視する
const ZOOM_ENTRY_REGEXP =
  /\[(.*?)\] (\d{2}:\d{2}:\d{2})(?:\r?\n|\r\n?)(.*?)(?=\r?\n|\r\n?\[|$)/gs

/** batch の ZoomParser が拾う発言時刻（秒）。一致が無ければ batch は Zoom 形式として扱わない */
export const extractZoomSpeakedAtSeconds = (transcript: string): number[] =>
  Array.from(transcript.matchAll(ZOOM_ENTRY_REGEXP), (match) => {
    const [hours, minutes, seconds] = match[2].split(':').map(Number)
    return hours * 60 * 60 + minutes * 60 + seconds
  })

export const calculateZoomTextDuration = (transcript: string): number => {
  const times = extractZoomSpeakedAtSeconds(transcript)

  if (times.length <= 1) return 0

  return times[times.length - 1] - times[0]
}
